import PropTypes from 'prop-types'
import Button from './Button'

const Header = ({title , onAdd ,showAdd}) => {
    // const onClick = ()=>{
    //     console.log('click')
    // }
  return (
    <header className='header'>
        <h1>{title}</h1>
        <Button  color={showAdd ? 'salmon' :'purple'} 
        text={showAdd ? 'CLOSE' :'ADD'} 
        onClick={onAdd} />       
    </header>
  )
}

Header.defaultProps ={
    title:'Task Remainder'
}

Header.propTypes = {
    title: PropTypes.string.isRequired ,
}



// const headingstyle = {
//     color:'red', backgroundColor:'black'
// } 
export default Header